// extracted by mini-css-extract-plugin
module.exports = {"raw":"RawDataDisplay_raw_1ajqt"};